<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,2C4.06,2,5.08,2.16,6.06,2.45C6.19,1.74,6.58,1.13,7.11,0.69C5.82,0.25,4.44,0,3,0C2.45,0,2,0.45,2,1C2,1.55,2.45,2,3,2C3,2,3,2,3,2ZM2,12C0.9,12,0,12.9,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,12.9,3.1,12,2,12C2,12,2,12,2,12ZM10.32,5.67C10.5,5.85,10.75,5.96,11.02,5.96C11.29,5.96,11.54,5.85,11.72,5.67C11.72,5.67,15.7,1.69,15.7,1.69C15.89,1.51,16,1.27,16,0.99C16,0.44,15.55,0,15,0C14.72,0,14.48,0.11,14.3,0.29C14.3,0.29,11.02,3.57,11.02,3.57C11.02,3.57,9.73,2.28,9.73,2.28C9.55,2.1,9.3,1.99,9.03,1.99C8.48,1.99,8.03,2.44,8.03,2.98C8.03,3.25,8.14,3.5,8.32,3.68C8.32,3.68,10.32,5.67,10.32,5.67C10.32,5.67,10.32,5.67,10.32,5.67ZM14.05,6.2C14.05,6.2,13.12,7.13,13.12,7.13C13.12,7.13,13.1,7.11,13.1,7.11C12.93,7.28,12.75,7.44,12.54,7.56C13.47,9.16,14,11.02,14,13C14,13.55,14.45,14,15,14C15.55,14,16,13.55,16,13C16,10.5,15.27,8.18,14.05,6.2C14.05,6.2,14.05,6.2,14.05,6.2ZM3,8C2.45,8,2,8.45,2,9C2,9.55,2.45,10,3,10C4.66,10,6,11.34,6,13C6,13.55,6.45,14,7,14C7.55,14,8,13.55,8,13C8,10.24,5.76,8,3,8C3,8,3,8,3,8ZM8.91,7.09C8.91,7.09,8.88,7.12,8.88,7.12C8.88,7.12,6.88,5.12,6.88,5.12C6.88,5.12,6.91,5.09,6.91,5.09C6.8,4.98,6.68,4.89,6.58,4.76C5.48,4.28,4.28,4,3,4C2.45,4,2,4.45,2,5C2,5.55,2.45,6,3,6C6.87,6,10,9.13,10,13C10,13.55,10.45,14,11,14C11.55,14,12,13.55,12,13C12,11.13,11.43,9.39,10.45,7.94C9.84,7.83,9.32,7.52,8.91,7.09C8.91,7.09,8.91,7.09,8.91,7.09Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FeedSubscribed',
} as DefineComponent
</script>
